module.exports = __webpack_public_path__ + "img/logo.db5ff250.png";